<template>
  <FileUploadField
    name="passport"
    iconType="NameUserCard"
    iconColor="#00D6BF"
    :errors="form.passportErrors"
    :label="$t('FileUploadField.label.passport')"
    :placeholder="$t('FileUploadField.placeholder.selectOrDrag')"
    @updateFile="updateFile"
  />
</template>

<script setup>
import { ref, watch, computed } from "vue";
import FileUploadField from "@/components/ui/inputs/FileUploadField.vue";
import useFormValidation from "@/composables/validations/useFormValidation";
import { useIdentityStore } from "@/stores/forms/identityFormStore";

const store = useIdentityStore();
const { validateFileInput } = useFormValidation();

const form = ref({
  passport: [],
  passportErrors: null,
});
const $emit = defineEmits(["enableSubmitButton"]);
const updateFile = (file) => {
  const fileValidationErrors = validateFileInput("passport", file);

  form.value.passport = file;
  store.updateValue("passport", form.value.passport);
  store.updateState("passport", fileValidationErrors);
  form.value.passportErrors = fileValidationErrors;
};

const formHasErrors = computed(() => {
  const anyErrors = form.value.passportErrors !== "";
  const anyFieldsEmpty = form.value.passport.length === 0;

  return anyErrors || anyFieldsEmpty;
});

watch(
  () => formHasErrors.value,
  () => {
    $emit("enableSubmitButton", formHasErrors.value);
  },
  { deep: true }
);
</script>
<style lang="scss" scoped></style>
